import { types } from 'mobx-state-tree'

export const HourlyActivity = types.model('HourlyActivity').props({
  value: types.number,
  scaledValue: types.number,
})
